import React, { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { dateFormatByAccountCulture, determineCommaSeprater, dropDownSelectionStyles, formatNumberCustomoriginalapiv2, getFormattedCustomField, getValueFromResource, validateCultureNumber } from '../../common/timeLiveFunction';
import { KTSVG } from '../../_metronic/helpers';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import moment from 'moment';
import { CurrentCultureDateFormat } from '../../common/UiUtilities';
import CustomDropdownModal from './CustomDropdownModal';
import fetchIntegrationAPI from '../../common/fetchIntegrationAPI';
import { addCalendarTimeEntry, UpdateCalendarTimeEntry, updateEventFalg } from './CalendarSlice';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import { SelectionOption } from './TimeEntrySelection';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import './calendar.css';
import { getDecimalFromTime } from '../../common/timesheetFunction';
import { ShowToast } from '../../common/Toastr';
import { WorkingHours } from './WorkingHours';
import { CustomCalendarContainer } from '../../common/CustomCalendarContainer';

interface AddEventModalProps {
    modelRef?: any;
    t: any;
    oncloseModal: () => void;
    onSave: (event: any) => void;
    clickedDate?: any;
    selectedEvent?: any;
    presetStartTime: string;
    presetEndTime: string;
    setTimesheetEvents?: any;
}

const AddEventModal: React.FC<AddEventModalProps> = ({
    t,
    oncloseModal,
    onSave,
    clickedDate = new Date(),
    selectedEvent,
    presetStartTime,
    presetEndTime,
    setTimesheetEvents
}) => {
    const dispatch = useAppDispatch();
    const { isLoading } = useAppSelector((state) => state.expensetype);
    const { calendarStartDay, maxMenuHeight, showClientInTimesheet, showCostCenterInTimeSheet, showWorkTypeInTimeSheet, customFieldInsertionFormat, CurrentCultureDateFormat, cultureInfoName, decimalPlaces } = useAppSelector((state) => state.globalState);
    const { Submitted, TimeEntryViewType, AccountEmployeeTimeEntryPeriodId, TimeEntryEndDate, TimeEntryStartDate, timeEntryData, isLocked, customFields, isShowCustomFields, workingDayType, DummyRangePeriod } = useAppSelector((state) => state.calendar);
    const [eventDate, setEventDate] = useState<Date>(clickedDate);
    const [eventEndDate, setEventEndDate] = useState<Date>(clickedDate);
    const [eventName, setEventName] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [totalTime, setTotalTime] = useState('');
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [selectedClient, setSelectedClient] = useState<SelectionOption>({ label: '', value: null });
    const [selectedProject, setSelectedProject] = useState({ label: '', value: null, clientId: null });
    const [selectedTask, setSelectedTask] = useState<SelectionOption>({ label: '', value: null });
    const [selectedCost, setSelectedCost] = useState<SelectionOption>({ label: '', value: null });
    const [selectedWorktype, setSelectedWorktype] = useState<SelectionOption>({ label: '', value: null });
    const [description, setDescription] = useState('');
    const [timesheetError, setTimesheetError] = useState([]);
    const [splithours, setSplitHours] = useState<any>([]);
    const [showTimezonePopover, setShowTimezonePopover] = useState(false);
    const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const iconRef = useRef<HTMLDivElement>(null);
    const [popoverPosition, setPopoverPosition] = useState({ top: 0, left: 0 });
    const endDateInputRef = useRef<HTMLInputElement>(null);
    const [showFields, setShowFields] = useState(false);
    const [cfValues, setCfValues] = useState<any>({
        CustomField1: "",
        CustomField2: "",
        CustomField3: "",
        CustomField4: "",
        CustomField5: "",
        CustomField6: "",
        CustomField7: "",
        CustomField8: "",
        CustomField9: ""
    });
    const [cfValuesUpdate, setCfValuesUpdate] = useState<any>({
        CustomField1: "",
        CustomField2: "",
        CustomField3: "",
        CustomField4: "",
        CustomField5: "",
        CustomField6: "",
        CustomField7: "",
        CustomField8: "",
        CustomField9: ""
    });
    const AccountId = localStorage.getItem('accountId');
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');
    const sourceId = selectedEvent?.extendedProps?.type || '';
    const updateInternalEvent = selectedEvent?.extendedProps?.type === 'internal' && selectedProject?.value == null && selectedClient?.value == null;
    const calculateTotalTime = (start: string, end: string) => {
        if (!start || !end) return '';
        const startDate = new Date(`1970-01-01T${start}`);
        const endDate = new Date(`1970-01-01T${end}`);
        const diffMs = endDate.getTime() - startDate.getTime();
        if (isNaN(diffMs) || diffMs < 0) return '';
        const hrs = String(Math.floor(diffMs / 3600000)).padStart(2, '0');
        const mins = String(Math.floor((diffMs % 3600000) / 60000)).padStart(2, '0');
        return `${hrs}:${mins}:00`;
    };

    const setDefaultTimes = (baseDate: Date) => {
        const start = moment(baseDate).format("HH:mm");
        const end = moment(baseDate).add(1, 'hour').format("HH:mm");
        setStartTime(start);
        setEndTime(end);
        setTotalTime(calculateTotalTime(start, end));
    };

    const getDisplayText = () => {
        const task = selectedTask?.label;

        const others = [
            selectedClient?.label,
            selectedProject?.label
                ? selectedProject.label
                : (
                    <span style={{ color: '#172b4d' }}>
                        {`${getValueFromResource('Select', dispatch, t)} ` + [
                            showClientInTimesheet && getValueFromResource('Client', dispatch, t),
                            getValueFromResource('Project', dispatch, t),
                            getValueFromResource('Task', dispatch, t),
                            showCostCenterInTimeSheet && getValueFromResource('Cost Center', dispatch, t),
                            showWorkTypeInTimeSheet && getValueFromResource('Work Type', dispatch, t),
                        ].filter(Boolean).join(' - ')}
                    </span>
                    // <span style={{ color: '#172b4d' }}>
                    //     {`${getValueFromResource('Select Project', dispatch, t)} - ${getValueFromResource('Task', dispatch, t)}`}
                    // </span>
                ),
            selectedCost?.label,
            selectedWorktype?.label,
        ].filter(Boolean);

        return (
            <div>
                {(sourceId === 'timeEntry' || sourceId === 'internal') ? (
                    <div>
                        <div><strong>{task}</strong></div>
                        {others.length > 0 && (
                            <div style={{ fontSize: '12px', color: '#555' }}>
                                {others.map((item, i) => (
                                    <span key={i} className="rowItemColor">
                                        {i > 0 && ' • '}
                                        {item}
                                    </span>
                                ))}
                            </div>
                        )}
                    </div>
                ) : (
                    <div>
                        {!dropdownVisible && task && <div><strong>{task}</strong></div>}
                        {!dropdownVisible && others.length > 0 ? (
                            <div style={{ fontSize: '12px', color: '#555' }}>
                                {others.map((item, i) => (
                                    <span key={i} className="rowItemColor">
                                        {i > 0 && ' • '}
                                        {item}
                                    </span>
                                ))}
                            </div>
                        ) : (
                            <span style={{ color: '#172b4d' }}>
                                {`${getValueFromResource('Select', dispatch, t)} ` + [
                                    showClientInTimesheet && getValueFromResource('Client', dispatch, t),
                                    getValueFromResource('Project', dispatch, t),
                                    getValueFromResource('Task', dispatch, t),
                                    showCostCenterInTimeSheet && getValueFromResource('Cost Center', dispatch, t),
                                    showWorkTypeInTimeSheet && getValueFromResource('Work Type', dispatch, t),
                                ].filter(Boolean).join(' - ')}
                            </span>
                            // <span style={{ color: '#172b4d' }}>
                            //     {`${getValueFromResource('Select Project', dispatch, t)} - ${getValueFromResource('Task', dispatch, t)}`}
                            // </span>
                        )}
                    </div>
                )}
            </div>
        );
    };

    const handleSubmit = async () => {
        if (startTime === endTime && moment(eventDate).isSame(moment(eventEndDate), 'day')) {
            ShowToast('error', 'Start and end Date/Time cannot be the same.', "error", "toast-top-right");
            return;
        }

        const formattedCfValues: any = {};
        Object.keys(cfValues).forEach(key => {
            formattedCfValues[key] = getFormattedCustomField(customFields, key, cfValues[key]);
        });

        let payload: any[] = [];

        if (sourceId === 'outlook' || sourceId === 'google' || sourceId === 'internal') {

            if (!showFields) {
                payload = splithours?.filter((item: any) => item.Locked === false)?.map((item: any) => {
                    const matchedPeriod = DummyRangePeriod.find((period: any) =>
                        moment(item.date).isBetween(
                            moment(period.TimeEntryStartDate),
                            moment(period.TimeEntryEndDate),
                            'day',
                            '[]'
                        )
                    );

                    return {
                        AccountId,
                        ModifiedByEmployeeId: AccountEmployeeId,
                        IsTimeOff: false,
                        IsSubmitted: Submitted,
                        TimesheetPeriodType: TimeEntryViewType,
                        AccountEmployeeTimeEntryPeriodId: matchedPeriod ? matchedPeriod.AccountEmployeeTimeEntryPeriodId : AccountEmployeeTimeEntryPeriodId,
                        AccountEmployeeId,
                        AccountEmployeeTimeEntryId: 0,
                        AccountClientId: !showClientInTimesheet ? selectedProject?.clientId : selectedClient.value ?? 0,
                        AccountProjectId: selectedProject?.value ?? 0,
                        AccountProjectTaskId: selectedTask?.value ?? 0,
                        AccountCostCenterId: selectedCost?.value ?? 0,
                        AccountWorkTypeId: selectedWorktype?.value ?? 0,
                        AccountTimeOffTypeId: null,
                        Hours: getDecimalFromTime(item?.duration, false),
                        Percentage: null,
                        PeriodStartDate: matchedPeriod ? matchedPeriod.TimeEntryStartDate : TimeEntryStartDate,
                        PeriodEndDate: matchedPeriod ? matchedPeriod.TimeEntryEndDate : TimeEntryEndDate,
                        TimeEntryDate: item?.date,
                        StartTime: moment(item?.startDateTime).format("YYYY-MM-DDTHH:mm:ss"),
                        EndTime: moment(item?.endDateTime).format("YYYY-MM-DDTHH:mm:ss"),
                        Description: description || '',
                        ...formattedCfValues
                        // ...cfValues
                    };
                });
            } else {

                const startDateTime = moment(`${moment(eventDate).format("YYYY-MM-DD")}T${startTime}`);
                const endDateTime = moment(`${moment(eventDate).format("YYYY-MM-DD")}T${endTime}`);
                const hours = getDecimalFromTime(totalTime, false);

                const matchedPeriod = DummyRangePeriod.find((period: any) =>
                    moment(eventDate).isBetween(
                        moment(period.TimeEntryStartDate),
                        moment(period.TimeEntryEndDate),
                        'day',
                        '[]'
                    )
                );

                payload = [{
                    AccountId,
                    ModifiedByEmployeeId: AccountEmployeeId,
                    IsTimeOff: false,
                    IsSubmitted: Submitted,
                    TimesheetPeriodType: TimeEntryViewType,
                    AccountEmployeeTimeEntryPeriodId: matchedPeriod ? matchedPeriod.AccountEmployeeTimeEntryPeriodId : AccountEmployeeTimeEntryPeriodId,
                    AccountEmployeeId,
                    AccountEmployeeTimeEntryId: 0,
                    AccountClientId: !showClientInTimesheet ? selectedProject?.clientId : selectedClient.value ?? 0,
                    AccountProjectId: selectedProject?.value ?? 0,
                    AccountProjectTaskId: selectedTask?.value ?? 0,
                    AccountCostCenterId: selectedCost?.value ?? 0,
                    AccountWorkTypeId: selectedWorktype?.value ?? 0,
                    AccountTimeOffTypeId: null,
                    Hours: hours,
                    Percentage: null,
                    PeriodStartDate: matchedPeriod ? matchedPeriod.TimeEntryStartDate : TimeEntryStartDate,
                    PeriodEndDate: matchedPeriod ? matchedPeriod.TimeEntryEndDate : TimeEntryEndDate,
                    TimeEntryDate: moment(eventDate).format("YYYY-MM-DD"),
                    StartTime: startDateTime.format("YYYY-MM-DDTHH:mm:ss"),
                    EndTime: endDateTime.format("YYYY-MM-DDTHH:mm:ss"),
                    Description: description || '',
                    ...formattedCfValues
                    // ...cfValues
                }];
            }
        } else if (sourceId === 'timeEntry') {
            const { AccountEmployeeId, AccountWorkTypeId, AccountEmployeeTimeEntryPeriodId, AccountId, Submitted, AccountEmployeeTimeEntryId } = selectedEvent?.extendedProps;
            payload = [{
                IsTimeOff: false,
                IsSubmitted: Submitted,
                TimesheetPeriodType: TimeEntryViewType,
                AccountEmployeeTimeEntryPeriodId: AccountEmployeeTimeEntryPeriodId,
                AccountEmployeeId,
                AccountEmployeeTimeEntryId: AccountEmployeeTimeEntryId,
                AccountClientId: !showClientInTimesheet ? selectedProject?.clientId : selectedClient.value ?? 0,
                AccountProjectId: selectedProject?.value ?? 0,
                AccountProjectTaskId: selectedTask?.value ?? 0,
                AccountCostCenterId: selectedCost?.value ?? 0,
                AccountWorkTypeId: !showWorkTypeInTimeSheet ? AccountWorkTypeId : selectedWorktype?.value ?? 0,
                AccountTimeOffTypeId: null,
                Hours: getDecimalFromTime(totalTime, false),
                Percentage: null,
                PeriodStartDate: moment(TimeEntryStartDate).format("YYYY-MM-DD"),
                PeriodEndDate: moment(TimeEntryEndDate).format("YYYY-MM-DD"),
                TimeEntryDate: moment(eventDate).format("YYYY-MM-DD"),
                StartTime: moment(`${moment(eventDate).format("YYYY-MM-DD")} ${startTime}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DDTHH:mm:ss"),
                EndTime: moment(`${moment(eventDate).format("YYYY-MM-DD")} ${endTime}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DDTHH:mm:ss"),
                Description: description || '',
                ...formattedCfValues
                // ...cfValues
            }];
        }

        const response = await dispatch(addCalendarTimeEntry(payload));
        const result = response.payload;
        if (String(result?.StatusCode) !== '201') {
            setTimesheetError(result?.Data || []);
            return;
        } else {
            dispatch(updateEventFalg(true));
            oncloseModal();
        }
        dispatch(updateEventFalg(true));
        oncloseModal();
    };

    const handleDelete = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "", 'Yes delete it!', 'custom-swal-container')
            .then(result => {
                if (result && selectedEvent?.id) {
                    if (sourceId === 'timeEntry') {
                        const { AccountEmployeeId, AccountEmployeeTimeEntryId, AccountClientId, AccountEmployeeTimeEntryPeriodId, AccountEmployeeTimeEntryApprovalProjectId, AccountId, AccountProjectId, AccountProjectTaskId, AccountWorkTypeId, AccountCostCenterId, Description, Submitted } = selectedEvent?.extendedProps;
                        dispatch(UpdateCalendarTimeEntry({
                            AccountId,
                            AccountEmployeeId,
                            AccountEmployeeTimeEntryPeriodId: AccountEmployeeTimeEntryPeriodId,
                            ApprovalProjectId: AccountEmployeeTimeEntryApprovalProjectId,
                            AccountClientId: AccountClientId,
                            AccountProjectId: AccountProjectId,
                            AccountProjectTaskId: AccountProjectTaskId,
                            AccountEmployeeTimeEntryIds: String(AccountEmployeeTimeEntryId),
                            IsDelete: true,
                            ModifiedByEmployeeId: AccountEmployeeId,
                            AccountCostCenterId: AccountCostCenterId,
                            AccountWorkTypeId: AccountWorkTypeId
                        }))
                            .unwrap()
                            .then(() => {
                                if (setTimesheetEvents) {
                                    setTimesheetEvents((prev: any) =>
                                        prev.filter((event: any) =>
                                            event.id !== selectedEvent.id.toString()
                                        )
                                    );
                                }
                                dispatch(updateEventFalg(true));
                                oncloseModal();
                            })
                            .catch(error => {
                                console.error('Error deleting time entry:', error);
                                ShowToast('error', 'Failed to delete time entry', "error", "toast-top-right");
                            });
                    }
                }
            });
        oncloseModal();
    };

    const onChangeHandler = (e: any) => {
        setCfValues({ ...cfValues, [e.target.name]: e.target.value });
    }

    const onChangeHandlerForDatePicker = (e: any, name: any) => {
        const date = e ? moment(e).format(customFieldInsertionFormat) : moment().format(customFieldInsertionFormat);
        setCfValues({ ...cfValues, [name]: date });
    }

    const getTimesheetRecordById = async () => {
        const { AccountEmployeeTimeEntryId } = selectedEvent?.extendedProps
        if (AccountEmployeeTimeEntryId) {
            try {
                const response = await fetchIntegrationAPI(`api/Timesheet/GetAccountEmployeeTimeEntryByTimeEntryId/${AccountEmployeeId}/${AccountEmployeeTimeEntryId}`, 'GET', "", true);
                const json = await response.json();
                if (json?.StatusCode === '200' && json?.Data && json.Data.length > 0) {
                    const record = json.Data[0];
                    console.log(record, customFields, "record")
                    const {
                        AccountClientId,
                        AccountCostCenter,
                        AccountCostCenterId,
                        AccountProjectId,
                        AccountProjectTaskId,
                        AccountWorkType,
                        AccountWorkTypeId,
                        ClientName,
                        CustomField1,
                        CustomField2,
                        CustomField3,
                        CustomField4,
                        CustomField5,
                        CustomField6,
                        CustomField7,
                        CustomField8,
                        CustomField9,
                        Description,
                        EndTime,
                        ProjectName,
                        StartTime,
                        TaskName,
                        TimeEntryDate,
                    } = record;
                    const ProjectObj = { label: ProjectName, value: AccountProjectId, clientId: AccountClientId };
                    const TaskObj = { label: TaskName, value: AccountProjectTaskId };
                    const ClientObj = { label: ClientName, value: AccountClientId };
                    const WorkTypeObj = { label: AccountWorkType, value: AccountWorkTypeId };
                    const CostCenterObj = { label: AccountCostCenter, value: AccountCostCenterId };

                    if ((showClientInTimesheet || showClientInTimesheet)) setSelectedClient(ClientObj);
                    if (showCostCenterInTimeSheet) setSelectedCost(CostCenterObj);
                    if (showWorkTypeInTimeSheet) setSelectedWorktype(WorkTypeObj);
                    setSelectedProject(ProjectObj);
                    setSelectedTask(TaskObj);
                    setEventName(ClientName || '');
                    setDescription(Description || '');
                    if (!StartTime && !EndTime) {
                        const defaultStart = moment("09:00", "HH:mm");
                        const durationHours = record.Hours || 1;

                        const defaultEnd = moment(defaultStart).add(durationHours, "hours");

                        const formattedStartTime = defaultStart.format("HH:mm");
                        const formattedEndTime = defaultEnd.format("HH:mm");

                        setStartTime(formattedStartTime);
                        setEndTime(formattedEndTime);
                        setTotalTime(calculateTotalTime(formattedStartTime, formattedEndTime));
                    } else {
                        const formattedStartTime = moment(StartTime).format("HH:mm");
                        const formattedEndTime = moment(EndTime).format("HH:mm");

                        setStartTime(formattedStartTime);
                        setEndTime(formattedEndTime);
                        setTotalTime(calculateTotalTime(formattedStartTime, formattedEndTime));
                    }
                    const dateField = moment(TimeEntryDate).format('YYYY-MM-DD');
                    // setEventDate(new Date(dateField));
                    setEventDate(new Date(TimeEntryDate));
                    const updatedCfValues: any = {};
                    const fieldList = [
                        "CustomField1", "CustomField2", "CustomField3",
                        "CustomField4", "CustomField5", "CustomField6",
                        "CustomField7", "CustomField8", "CustomField9"
                    ];

                    fieldList.forEach(fieldName => {
                        const value = record[fieldName];
                        const fieldConfig = customFields?.find((cf: any) => cf.DatabaseFieldName === fieldName);
                        if (fieldConfig && fieldConfig.MasterCustomDataTypeName === "Number" && value) {
                            updatedCfValues[fieldName] = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), value, decimalPlaces);
                        } else {
                            updatedCfValues[fieldName] = value || "";
                        }
                    });
                    console.log(updatedCfValues, "updatedCfValues")
                    setCfValues(updatedCfValues);
                    setCfValuesUpdate(updatedCfValues);
                    // const updatedCfValues = {
                    //     CustomField1: CustomField1 ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), CustomField1, decimalPlaces, customFields) : CustomField1 || "",
                    //     CustomField2: CustomField2 || "",
                    //     CustomField3: CustomField3 || "",
                    //     CustomField4: CustomField4 || "",
                    //     CustomField5: CustomField5 || "",
                    //     CustomField6: CustomField6 || "",
                    //     CustomField7: CustomField7 || "",
                    //     CustomField8: CustomField8 || "",
                    //     CustomField9: CustomField9 || ""
                    // };
                    // setCfValues(updatedCfValues);
                    // setCfValuesUpdate(updatedCfValues);

                } else {
                    console.error("Invalid response format:", json);
                }
            } catch (error) {
                console.error("Error fetching timesheet record:", error);
                ShowToast('error', error, "error", "toast-top-right");
            }
        }
    }

    const calculateDailySplitHours = (start: Date, end: Date, workingHours = 8, DummyRangePeriod: any[] = [], Submitted?: boolean) => {
        const results: {
            date: string;
            duration: string;
            type: string;
            startDateTime: string;
            endDateTime: string;
            Locked: boolean;
        }[] = [];

        let current = moment(start).startOf('day');
        const endDay = moment(end).startOf('day');

        while (current.isSameOrBefore(endDay, 'day')) {
            let dayStart = current.clone();
            let dayEnd = current.clone().add(1, 'day').startOf('day');
            // let dayEnd = current.clone().endOf('day');

            if (current.isSame(moment(start), 'day')) {
                dayStart = moment(start);
            }
            if (current.isSame(moment(end), 'day')) {
                dayEnd = moment(end);
            }

            const diffMinutes = dayEnd.diff(dayStart, "minutes");
            let remainingMinutes = diffMinutes;
            let chunkStart = dayStart.clone();

            while (remainingMinutes > 0) {
                const chunkMinutes = Math.min(workingHours * 60, remainingMinutes);
                const chunkEnd = chunkStart.clone().add(chunkMinutes, "minutes");

                const hours = Math.floor(chunkMinutes / 60);
                const minutes = chunkMinutes % 60;
                const formatted = `${hours.toString().padStart(2, "0")}:${minutes
                    .toString()
                    .padStart(2, "0")}`;
                const matchedPeriod = DummyRangePeriod?.find((period: any) =>
                    moment(current).isBetween(
                        moment(period.TimeEntryStartDate),
                        moment(period.TimeEntryEndDate),
                        'day',
                        '[]'
                    )
                );

                results.push({
                    date: current.format("YYYY-MM-DD"),
                    duration: formatted,
                    type: chunkMinutes === workingHours * 60 ? "working" : "remaining",
                    startDateTime: chunkStart.format("YYYY-MM-DD HH:mm"),
                    endDateTime: chunkEnd.format("YYYY-MM-DD HH:mm"),
                    Locked: matchedPeriod && ((matchedPeriod.LockApprovedRecords && Boolean(matchedPeriod.Approved)) || (matchedPeriod.LockSubmittedRecords && Boolean(matchedPeriod.Submitted))) ? true : false,
                });

                chunkStart = chunkEnd.clone();
                remainingMinutes -= chunkMinutes;
            }

            current.add(1, "day");
        }
        return results;
    };

    const calculateTime = (startDate: Date, endDate: Date, start: string, end: string) => {
        if (!start || !end) return '';

        const [sh, sm] = start.split(':').map(Number);
        const [eh, em] = end.split(':').map(Number);
        const startDateTime = moment(startDate).set({ hour: sh, minute: sm, second: 0 });
        let endDateTime = moment(endDate).set({ hour: eh, minute: em, second: 0 });

        const diffMs = endDateTime.diff(startDateTime);
        const hrs = String(Math.floor(diffMs / 3600000)).padStart(2, '0');
        const mins = String(Math.floor((diffMs % 3600000) / 60000)).padStart(2, '0');
        return `${hrs}:${mins}:00`;
    };

    const updateTotalTime = () => {
        setTotalTime(calculateTime(eventDate, eventEndDate, startTime, endTime));
    };

    const handlePopoverMouseEnter = () => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
    };

    const handlePopoverMouseLeave = () => {
        hoverTimeoutRef.current = setTimeout(() => {
            setShowTimezonePopover(false);
        }, 100);
    }

    const handleIconMouseEnter = () => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        setShowTimezonePopover(true);
    };

    const handleIconMouseLeave = () => {
        hoverTimeoutRef.current = setTimeout(() => {
            setShowTimezonePopover(false);
        }, 1000);
    };

    const calculatePopoverPosition = () => {
        if (iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect();
            setPopoverPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX
            });
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;

            if (dropdownVisible &&
                dropdownRef.current &&
                !dropdownRef.current.contains(target) &&
                !target.closest?.('.dropdown-trigger')) {
                setDropdownVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownVisible]);

    useEffect(() => {
        if (showTimezonePopover) {
            calculatePopoverPosition();
            window.addEventListener('resize', calculatePopoverPosition);
            window.addEventListener('scroll', calculatePopoverPosition);

            return () => {
                window.removeEventListener('resize', calculatePopoverPosition);
                window.removeEventListener('scroll', calculatePopoverPosition);
            };
        }
    }, [showTimezonePopover, iconRef]);

    useEffect(() => {
        if (selectedEvent?.start && selectedEvent?.end) {
            const SplitHours = calculateDailySplitHours(
                new Date(selectedEvent.start),
                new Date(selectedEvent.end),
                workingDayType[0]?.HoursPerDay,
                DummyRangePeriod,
            );
            setSplitHours(SplitHours);
        }
    }, [selectedEvent, DummyRangePeriod]);

    useEffect(() => {
        if (sourceId === 'timeEntry') {
            getTimesheetRecordById();
        }
    }, [selectedEvent, sourceId])

    useEffect(() => {
        if (!selectedEvent) {
            if (presetStartTime && presetEndTime) {
                setStartTime(presetStartTime);
                setEndTime(presetEndTime);
                setTotalTime(calculateTotalTime(presetStartTime, presetEndTime));
            } else {
                setDefaultTimes(new Date());
            }
            return;
        }

        const { title, start, end, extendedProps } = selectedEvent;
        const description = (sourceId === 'google' || sourceId === 'outlook') ? [title, extendedProps?.Description].filter(Boolean).join(' - ') : extendedProps?.Description ?? '';
        const startFormatted = moment(start).format("HH:mm");
        const endFormatted = moment(end).format("HH:mm");
        const safeStart = start ? new Date(start) : new Date();
        const safeEnd = end ? new Date(end) : start ? new Date(start) : new Date();
        setEventName(title || '');
        setDescription(description);
        setStartTime(startFormatted);
        setEndTime(endFormatted);
        // setTotalTime(calculateTotalTime(startFormatted, endFormatted));
        setTotalTime(calculateTime(safeStart, safeEnd, startFormatted, endFormatted))
        setEventDate(safeStart);
        setEventEndDate(safeEnd);
        const newCfValues: any = { ...cfValues };
        Object.keys(newCfValues).forEach(key => {
            if (extendedProps?.[key] !== undefined) {
                newCfValues[key] = extendedProps[key];
            }
        });
        setCfValuesUpdate(newCfValues);

    }, [selectedEvent, sourceId, presetStartTime, presetEndTime]);

    useEffect(() => {
        if (customFields?.length > 0) {
            let NewCfValue = { ...cfValues };
            customFields?.filter((x: any) => !x.IsDisabled)
                .map((x: any) => {
                    if (cfValues[x.DatabaseFieldName] == "" && x.DefaultValue != "" && x.MasterCustomDataTypeName != "Date") {
                        NewCfValue[x.DatabaseFieldName] = x.DefaultValue;
                    }
                    if (cfValues[x.DatabaseFieldName] == "" && x.MasterCustomDataTypeName == "Date") {
                        NewCfValue[x.DatabaseFieldName] = moment(new Date()).format(customFieldInsertionFormat);
                    }
                });
            setCfValues(NewCfValue);
        }
    }, [])

    useEffect(() => {
        if (!updateInternalEvent) {
            updateTotalTime();
        }
    }, [eventDate, eventEndDate, startTime, endTime]);

    const isReadOnly = ['google', 'outlook', 'timeEntry', 'internal'].includes(sourceId);

    useEffect(() => {
        if (['google', 'outlook', 'internal'].includes(sourceId)) {
            const start = moment(eventDate);
            const end = moment(eventEndDate);
            const isSameDay = start.isSame(end, 'day');

            if (isSameDay) {
                const durationHours = end.diff(start, 'hours', true);
                setShowFields(durationHours <= (workingDayType[0]?.HoursPerDay || 8));
            } else {
                setShowFields(false);
            }
        }
    }, [eventDate, eventEndDate, sourceId, workingDayType]);

    return (
        <div className="card-body">
            {isLoading ? (
                <div className="col-md-12 text-center">
                    <span className='spinner-border spinner-border-md'></span>
                </div>
            ) : (
                <div className="modal drawer-overlay" style={{ display: 'block' }}>
                    <div className="modal-dialog" style={{ maxWidth: '650px' }}>
                        <div className="modal-content" style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                            <div className="modal-header justify-content-between" style={{ padding: '.6rem .6rem', flexShrink: 0 }}>
                                {selectedEvent ? (
                                    <div className="d-flex align-items-center">
                                        <h5 className="modal-title mainHeading">{(sourceId === 'timeEntry') ? getValueFromResource('Edit Time Entry', dispatch, t) : getValueFromResource('Create Time Entry', dispatch, t)}</h5>
                                        {((sourceId === 'timeEntry' && !isLocked)) && (
                                            <div className="btn btn-icon btn-active-light-dark btn-sm" onClick={handleDelete}>
                                                <i className="bi bi-trash fs-4 delete-menu-icon-color allign" data-tooltip-id="tooltip-TimeEntry" data-tooltip-content={getValueFromResource('Delete', dispatch, t)}></i>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <h5 className="modal-title mainHeading">Add Event</h5>
                                )}
                                <div className="btn btn-icon btn-sm btn-active-secondary" onClick={oncloseModal}>
                                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                                </div>
                            </div>
                            <div className="modal-body" style={{ overflowY: 'auto', flexGrow: 1 }} onScroll={() => {
                                setDropdownVisible(false);
                                setShowTimezonePopover(false)
                            }}>
                                {timesheetError.length > 0 && timesheetError.map((item: any) => (
                                    <div className="alert alert-danger py-2 px-3 mb-3">
                                        {item?.ErrorMessage}
                                    </div>
                                ))}
                                {(['google', 'outlook', 'timeEntry', 'internal'].includes(sourceId)) && (
                                    <>
                                        <div
                                            className="dropdown-trigger"
                                            style={{
                                                display: 'flex',
                                                cursor: (isReadOnly && isLocked) ? 'not-allowed' : 'pointer',
                                                border: "1px solid #eee",
                                                padding: "10px",
                                                borderRadius: "5px",
                                                opacity: (isReadOnly && isLocked) ? 0.6 : 1,
                                                pointerEvents: (isReadOnly && isLocked) ? 'none' : 'auto'
                                            }}
                                            onClick={() => {
                                                if ((isReadOnly && !isLocked)) {
                                                    setDropdownVisible(prev => !prev);
                                                }
                                            }}
                                        >
                                            {!(sourceId === 'timeEntry') && <i className="ki-outline ki-add-item fs-4" style={{ color: '#000' }}></i>}
                                            <span style={(sourceId === 'timeEntry') ? {} : { paddingLeft: 4 }}>{getDisplayText()}</span>
                                        </div>
                                        {dropdownVisible && (
                                            <div ref={dropdownRef}>
                                                <CustomDropdownModal
                                                    isCalendar
                                                    setDropdownVisible={setDropdownVisible}
                                                    preSelectedData={{
                                                        client: selectedClient,
                                                        project: selectedProject,
                                                        task: selectedTask,
                                                        cost: selectedCost,
                                                        worktype: selectedWorktype
                                                    }}
                                                    onSelectionComplete={({ client, project, task, cost, worktype }: any) => {
                                                        if (client) setSelectedClient(client);
                                                        if (project) setSelectedProject(project);
                                                        if (task) setSelectedTask(task);
                                                        if (cost) setSelectedCost(cost);
                                                        if (worktype) setSelectedWorktype(worktype);
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </>
                                )}
                                <div className="my-4">
                                    <label className="form-label fs-7 fw-normal mb-2">
                                        {getValueFromResource('Date & Time', dispatch, t)} {(['google', 'outlook', 'internal'].includes(sourceId) && !showFields) && <i className="bi bi-info-circle-fill fs-5 iconColor allign ms-1 cursor-pointer" data-tooltip-id="tooltip-TimeEntry" data-tooltip-content={getValueFromResource('Easily view and manage how your daily hours are divided across the day.', dispatch, t)}></i>}
                                    </label>

                                    {/* {(['google', 'outlook', 'internal'].includes(sourceId)) ? ( */}
                                    {(!showFields && !(sourceId === 'timeEntry')) ? (
                                        <div className="row g-2 align-items-center">
                                            <div className="col-md-4 position-relative">
                                                <DatePicker
                                                    selected={eventDate}
                                                    onChange={(date) => setEventDate(date || new Date())}
                                                    calendarStartDay={calendarStartDay}
                                                    className="form-control"
                                                    dateFormat={CurrentCultureDateFormat.toString()}
                                                    readOnly={true}
                                                    //readOnly={(((sourceId === 'google' || sourceId === 'outlook') || sourceId === 'timeEntry' || sourceId === 'internal') && isLocked)}
                                                    popperContainer={({ children }) => (
                                                        <CustomCalendarContainer inputRef={endDateInputRef}>
                                                            {children}
                                                        </CustomCalendarContainer>
                                                    )}
                                                />
                                                <i className="insideField-Icons ki-outline ki-calendar text-gray position-absolute top-50 end-0 translate-middle-y me-2"></i>
                                            </div>

                                            <div className="col-md-4 position-relative">
                                                <DatePicker
                                                    selected={eventEndDate}
                                                    onChange={(date) => {
                                                        const newDate = date || new Date();
                                                        setEventEndDate(newDate);
                                                        setTotalTime(calculateTime(eventDate, newDate, startTime, endTime));
                                                    }}
                                                    calendarStartDay={calendarStartDay}
                                                    className="form-control"
                                                    dateFormat={CurrentCultureDateFormat.toString()}
                                                    readOnly={true}
                                                    //readOnly={(((sourceId === 'google' || sourceId === 'outlook') || sourceId === 'timeEntry' || sourceId === 'internal') && isLocked)}
                                                    popperContainer={({ children }) => (
                                                        <CustomCalendarContainer inputRef={endDateInputRef}>
                                                            {children}
                                                        </CustomCalendarContainer>
                                                    )}
                                                />
                                                <i className="insideField-Icons ki-outline ki-calendar text-gray position-absolute top-50 end-0 translate-middle-y me-2"></i>
                                            </div>
                                            <div className="col-md-4 position-relative d-flex align-items-center" style={{ width: '29%' }}>
                                                <input
                                                    type="text"
                                                    className="form-control text-center fw-semibold"
                                                    name="totalTime"
                                                    value={totalTime}
                                                    readOnly
                                                    style={{ height: '40.95px' }}
                                                />
                                                {((sourceId === 'google' || sourceId === 'outlook') || sourceId === 'internal') && (
                                                    <>
                                                        <i
                                                            ref={iconRef}
                                                            className="bi bi-hourglass-split cursor-pointer text-primary ms-2"
                                                            data-tooltip-id="tooltip-TimeEntry"
                                                            data-tooltip-content={getValueFromResource('Time Allocation Split', dispatch, t)}
                                                            onMouseEnter={handleIconMouseEnter}
                                                            onMouseLeave={handleIconMouseLeave}
                                                            style={{ fontSize: '16px', position: 'absolute', right: '-23px', top: '12px' }}
                                                        ></i>
                                                        <WorkingHours position={popoverPosition} showTimezonePopover={showTimezonePopover} setShowTimezonePopover={setShowTimezonePopover} splithours={splithours} onClose={() => setShowTimezonePopover(false)} onMouseEnter={handlePopoverMouseEnter} onMouseLeave={handlePopoverMouseLeave} />
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="d-flex align-items-center gap-2 mb-4">
                                            <div className="col-md-3 wrapper">
                                                <DatePicker
                                                    selected={eventDate}
                                                    onChange={(date) => setEventDate(date || new Date())}
                                                    calendarStartDay={calendarStartDay}
                                                    className="form-control form-control-dark btn-icon-dark btn-text-dark"
                                                    dateFormat={CurrentCultureDateFormat.toString()}
                                                    popperContainer={({ children }) => (
                                                        <CustomCalendarContainer inputRef={endDateInputRef}>
                                                            {children}
                                                        </CustomCalendarContainer>
                                                    )}
                                                    readOnly={true}
                                                //readOnly={(((sourceId === 'google' || sourceId === 'outlook') || sourceId === 'timeEntry' || sourceId === 'internal') && isLocked)}
                                                >
                                                </DatePicker>
                                                <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                            </div>
                                            <div className="col-md-3 " >
                                                <input
                                                    type="time"
                                                    name="startTime"
                                                    value={startTime}
                                                    onChange={(e) => {
                                                        const newStartTime = e.target.value;
                                                        const newTotalTime = calculateTotalTime(newStartTime, endTime);
                                                        setStartTime(newStartTime);
                                                        setTotalTime(newTotalTime);
                                                    }}
                                                    className="form-control fs-7 fw-normal range-time"
                                                    style={{ height: '40.94px' }}
                                                    readOnly={true}
                                                //readOnly={(((sourceId === 'google' || sourceId === 'outlook') || sourceId === 'timeEntry' || sourceId === 'internal') && isLocked)}
                                                />
                                            </div>

                                            <div className="col-md-3">
                                                <input
                                                    type="time"
                                                    name="endTime"
                                                    value={endTime}
                                                    onChange={(e) => {
                                                        const newEndTime = e.target.value;
                                                        const newTotalTime = calculateTotalTime(startTime, newEndTime);
                                                        setEndTime(newEndTime);
                                                        setTotalTime(newTotalTime);
                                                    }}
                                                    className="form-control fs-7 fw-normal range-time"
                                                    style={{ height: '40.94px' }}
                                                    readOnly={true}
                                                //readOnly={(((sourceId === 'google' || sourceId === 'outlook') || sourceId === 'timeEntry' || sourceId === 'internal') && isLocked)}
                                                />
                                            </div>
                                            <div className="col-md-3 " style={{ maxWidth: "129px", position: 'relative' }}>
                                                <input
                                                    type="text"
                                                    className="form-control text-center fw-semibold"
                                                    name="totalTime"
                                                    value={totalTime}
                                                    readOnly
                                                    style={{ height: '40.95px' }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="my-4">
                                    <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Description', dispatch, t)}</label>
                                    <textarea
                                        rows={4}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        className="form-control"
                                        readOnly={(((sourceId === 'google' || sourceId === 'outlook') || sourceId === 'timeEntry' || sourceId === 'internal') && isLocked)}
                                    />
                                </div>

                                <div>
                                    {isShowCustomFields && customFields?.length > 0 && customFields?.filter((x: any) => !x.IsDisabled).map((x: any, index: any) => {
                                        return (
                                            <div key={index} className={"custom-field-item my-4"}>
                                                <label className={"d-block custom-field-label form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                {x.MasterCustomDataTypeName == "Drop-Down" &&
                                                    <select
                                                        name={x.DatabaseFieldName}
                                                        className={"form-control form-control-sm input-sm custom-field cf-select"}
                                                        onChange={onChangeHandler}
                                                        required={x.IsRequired ? x.IsRequired : ""}
                                                        disabled={isLocked ? true : false}
                                                        value={cfValues[x.DatabaseFieldName] || ""}
                                                    >
                                                        <option value="None">None</option>
                                                        {x.DropDownOptions != null &&
                                                            x.DropDownOptions.split("+").map((value: any, index: any) =>
                                                                <option key={index} value={value} >{value}</option>)
                                                        }
                                                    </select>}
                                                {x.MasterCustomDataTypeName == "Date" &&
                                                    <DatePicker
                                                        name={x.DatabaseFieldName}
                                                        onChange={(date) => onChangeHandlerForDatePicker(date, x.DatabaseFieldName)}
                                                        disabled={isLocked ? true : false}
                                                        calendarStartDay={calendarStartDay}
                                                        selected={(cfValues[x.DatabaseFieldName] ? dateFormatByAccountCulture(cfValues[x.DatabaseFieldName], cultureInfoName.toString()) : new Date())}
                                                        className={"form-control form-control-sm input-sm custom-field custom-field " + (isLocked ? 'disabled' : '')}
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                        popperContainer={({ children }) => (
                                                            <CustomCalendarContainer inputRef={endDateInputRef}>
                                                                {children}
                                                            </CustomCalendarContainer>
                                                        )}
                                                    />}
                                                {(x.MasterCustomDataTypeName == "Text") &&
                                                    <input
                                                        name={x.DatabaseFieldName}
                                                        defaultValue={selectedEvent ? cfValuesUpdate[x.DatabaseFieldName] : cfValues[x.DatabaseFieldName]}
                                                        value={cfValues[x.DatabaseFieldName] || ""}
                                                        onChange={onChangeHandler}
                                                        className={"form-control form-control-sm input-sm custom-field custom-field"}
                                                        maxLength={x.MaximumLength ? x.MaximumLength : ""}
                                                        max={x.MaximumValue ? x.MaximumValue : ""}
                                                        min={x.MinimumValue ? x.MinimumValue : ""}
                                                        required={x.IsRequired ? x.IsRequired : ""}
                                                        type="text"
                                                        disabled={isLocked ? true : false}
                                                    />}
                                                {(x.MasterCustomDataTypeName == "Number") &&
                                                    <input
                                                        name={x.DatabaseFieldName}
                                                        defaultValue={selectedEvent ? cfValuesUpdate[x.DatabaseFieldName] : cfValues[x.DatabaseFieldName]}
                                                        value={cfValues[x.DatabaseFieldName] || ""}
                                                        // onChange={onChangeHandler}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const isCommaSeparator = determineCommaSeprater(cultureInfoName.toString());
                                                            if (isCommaSeparator && value.includes('.')) {
                                                                return;
                                                            }
                                                            if (!isCommaSeparator && value.includes(',')) {
                                                                return;
                                                            }
                                                            if (value === "" || validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                                                setCfValues({ ...cfValues, [x.DatabaseFieldName]: value });
                                                            }
                                                        }}
                                                        onBlur={(e) => {
                                                            const value = e.target.value;

                                                            if (value === '') return;
                                                            const normalizedValue = value.toString().replace(',', '.');
                                                            const numericValue = parseFloat(normalizedValue);

                                                            if (isNaN(numericValue)) return;
                                                            const fixedValue = Number(numericValue.toFixed(decimalPlaces));
                                                            const formattedValue = formatNumberCustomoriginalapiv2(
                                                                cultureInfoName.toString(),
                                                                fixedValue,
                                                                decimalPlaces
                                                            );
                                                            setCfValues({ ...cfValues, [x.DatabaseFieldName]: formattedValue });
                                                        }}
                                                        className={"form-control form-control-sm input-sm custom-field custom-field"}
                                                        maxLength={x.MaximumLength ? x.MaximumLength : ""}
                                                        max={x.MaximumValue ? x.MaximumValue : ""}
                                                        min={x.MinimumValue ? x.MinimumValue : ""}
                                                        required={x.IsRequired ? x.IsRequired : ""}
                                                        type="text"
                                                        disabled={isLocked ? true : false}
                                                    />}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>

                            <div className="modal-footer d-flex justify-content-between align-items-center">
                                <div>
                                    {/* {!showFields && <strong className='fs-4' style={{ paddingLeft: '5px' }}>{totalTime}</strong>} */}
                                </div>
                                <div className='d-flex gap-2'>
                                    <button className="btn btn-secondary btn-sm" onClick={oncloseModal}>
                                        {getValueFromResource('Close', dispatch, t)}
                                    </button>
                                    <button className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={(((sourceId === 'google' || sourceId === 'outlook') || sourceId === 'timeEntry' || sourceId === 'internal') && isLocked)}>
                                        {getValueFromResource('Save', dispatch, t)}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <ReactTooltip
                id="tooltip-TimeEntry"
                style={{
                    fontSize: 12,
                    fontWeight: 'normal',
                    padding: 8,
                    borderRadius: 6,
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    backgroundColor: 'black',
                    color: 'white',
                    zIndex: 10000,
                    maxWidth: 220,
                    whiteSpace: 'normal'

                }}
                place="top"
            />
        </div>
    );
};

export default AddEventModal;
